import ProfileHeaderLoaderMobile from "./profileHeaderLoaderMobile/ProfileHeaderLoaderMobile";
import ProfileHeaderLoaderWeb from "./profileHeaderLoaderWeb/ProfileHeaderLoaderWeb";

function ProfileHeaderLoader(props) {
	if (props.isMobile) {
		return <ProfileHeaderLoaderMobile />;
	} else {
		return <ProfileHeaderLoaderWeb />;
	}
}

export default ProfileHeaderLoader;
